import { Feature } from "./feature.types";
import FeatureCard from "./FeatureCard";

const features: Feature[] = [
  { 
    icon: '🛒', 
    title: 'Gestão de Pedidos', 
    // description: 'Sistema completo de pedidos com integração para delivery, balcão e salão.' 
    description: 'Criação, edição e acompanhamento completo de todos os pedidos do seu restaurante.' 
  },
  { 
    icon: '📊', 
    title: 'Dashboard Inteligente', 
    description: 'Visualize métricas em tempo real: vendas, pedidos, itens mais vendidos e muito mais' 
  },
  // { 
  //   icon: '📊', 
  //   title: 'Controle de Estoque', 
  //   description: 'Monitore ingredientes, receba alertas de baixo estoque e gerencie fornecedores.' 
  // },
  { 
    icon: '🪑', 
    title: 'Controle de Mesas', 
    description: 'Gerencie suas mesas de forma visual e intuitiva, com status em tempo real.' 
  },
  // 🖥️ 🛒 🍽️ 🌐📱🔗📦
  { 
    icon: '🖨️', 
    title: 'Fila por Setor', 
    description: 'Pedidos organizados por local: Bar, Cozinha, Sobremesas. Cada setor recebe apenas o que precisa.' 
  },
  { 
    icon: '📱', 
    title: 'Menu Online', 
    description: 'QR Code para acesso instantâneo ao cardápio digital.' 
  },
  // { 
  //   icon: '🚚', 
  //   title: 'Delivery Integrado', 
  //   description: 'Sistema completo para delivery com cálculo automático de frete configurável.' 
  // },
  { 
    icon: '💰', 
    title: 'Relatórios Financeiros', 
    description: 'Dashboards completos com vendas, lucros, custos e análises detalhadas.' 
  },
  // { 
  //   icon: '👥', 
  //   title: 'Gestão de Funcionários', 
  //   description: 'Controle de horários, permissões de acesso e acompanhamento de performance.' 
  // },
  // { 
  //   icon: '📱', 
  //   title: 'App Mobile', 
  //   description: 'Acesse o sistema de qualquer lugar com nosso aplicativo mobile.' 
  // },
  // { 
  //   icon: '🔄', 
  //   title: 'Integrações', 
  //   description: 'Conecte com iFood, Uber Eats, sistemas de pagamento e outras ferramentas.' 
  // }
];


const Features: React.FC = () => (
  <section id="recursos" className="py-20 bg-gray-50">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-16">
        {/* <h2 className="text-4xl font-bold text-gray-900 mb-4">Recursos Poderosos</h2> */}
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Tudo que você precisa para gerir seu restaurante</h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          {/* Tudo que você precisa para gerenciar seu restaurante de forma eficiente */}
          Funcionalidades pensadas para facilitar o dia a dia e aumentar suas vendas
        </p>
      </div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <FeatureCard key={index} feature={feature} index={index} />
        ))}
      </div>
    </div>
  </section>
);

export default Features;